import React, { useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import { IconButton } from "@mui/material";
import EditPoleInSetModal from "../../modals/EditPoleInSetModal";

export const EditPoleInSetButton = ({
  polesetId,
  poleId,
  length,
  color,
}: {
  polesetId: string;
  poleId: string;
  length: number;
  color: string;
}) => {
  const [openDialog, setOpenDialog] = useState(false);

  return (
    <>
      <IconButton
        sx={{ "&:hover": { color: "secondary.main" } }}
        onClick={() => setOpenDialog(true)}
      >
        <EditIcon />
      </IconButton>

      <EditPoleInSetModal
        isOpen={openDialog}
        close={() => setOpenDialog(false)}
        setId={polesetId}
        poleId={poleId}
        length={length}
        color={color}
      />
    </>
  );
};
